import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {CartService} from '../../../../services/cart.service';
import {CdkScrollable} from '@angular/cdk/scrolling';
import {DecimalPipe, NgClass} from '@angular/common';
import {THEME_CONFIG} from '../../../../../environments/tokens/theme.token';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-order-offer-rules-dialog',
  templateUrl: './order-offer-rules-dialog.component.html',
  styleUrl: './order-offer-rules-dialog.component.scss',
  imports: [CdkScrollable, MatDialogContent, DecimalPipe,MatButton],
  standalone: true
})
export class OrderOfferRulesDialogComponent implements OnInit {
  protected readonly themeConfig = inject(THEME_CONFIG)

  readonly data = inject<{
    promotion: any;
    rules: any[];
    promoEligibleTotal: number;
  }>(MAT_DIALOG_DATA);

  private dialogRef = inject(MatDialogRef<OrderOfferRulesDialogComponent>);
  private cartService = inject(CartService);

  selectedRule: any = null;
  errorMessage: string = '';

  ngOnInit(): void {
    const eligibleRules = this.sortedRules.filter(rule => this.isEligible(rule));

    if (eligibleRules.length === 1) {
      this.selectedRule = eligibleRules[0];
      setTimeout(() => {
        this.dialogRef.close({action: 'confirm', rule: this.selectedRule});
      }, 0);
    }
  }

  selectRule(rule: any): void {
    this.selectedRule = rule;
    this.errorMessage = '';
  }

  isEligible(rule: any): boolean {
    return (
      this.data.promoEligibleTotal >= rule.min &&
      this.data.promoEligibleTotal <= rule.max
    );
  }

  getReductionLabel(rule: any): string {
    const r = rule.reduction;
    if (!r) return '';
    if (r.type === 'PERCENTAGE') {
      const pct = Math.round((r.value || 0) * 100);
      return pct === 100 ? 'Gratuit 🎁' : `-${pct}%`;
    }
    if (r.type === 'FIXED_AMOUNT') {
      return `-${r.value}€`;
    }
    return '';
  }

  // getMissingAmount(rule: any): number {
  //   if (this.data.promoEligibleTotal >= rule.min) return 0;
  //   return Math.ceil((rule.min - this.data.promoEligibleTotal) * 100) / 100;
  // }
  getMissingAmount(rule: any): number {
    if (this.data.promoEligibleTotal < rule.min) {
      return Math.ceil((rule.min - this.data.promoEligibleTotal) * 100) / 100;
    }
    return 0;
  }

  // confirm(): void {
  //   if (!this.selectedRule) {
  //     this.errorMessage = 'Veuillez sélectionner un intervalle.';
  //     return;
  //   }
  //
  //   if (!this.isEligible(this.selectedRule)) {
  //     const missing = this.getMissingAmount(this.selectedRule);
  //     this.errorMessage = `Votre panier n'atteint pas cet intervalle. Veuillez ajouter des produits éligibles (${missing.toFixed(2)}€ manquant${missing > 1 ? 's' : ''}).`;
  //     return;
  //   }
  //
  //   this.dialogRef.close({action: 'confirm', rule: this.selectedRule});
  // }
  confirm(): void {
    if (!this.selectedRule) {
      this.errorMessage = 'Veuillez sélectionner un intervalle.';
      return;
    }

    const total = this.data.promoEligibleTotal;
    const rule = this.selectedRule;

    if (total < rule.min) {
      const missing = this.getMissingAmount(rule);
      this.errorMessage = `Votre panier n'atteint pas cet intervalle. Veuillez ajouter des produits éligibles (${missing.toFixed(2)}€ manquant${missing > 1 ? 's' : ''}).`;
      return;
    }

    if (total > rule.max) {
      this.errorMessage = `Votre panier dépasse cet intervalle. Veuillez choisir un autre intervalle.`;
      return;
    }

    this.dialogRef.close({action: 'confirm', rule});
  }

  cancel(): void {
    this.dialogRef.close({action: 'cancel'});
  }

  get sortedRules(): any[] {
    return [...this.data.rules].sort((a, b) => a.min - b.min);
  }
}
